import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';
import PreWorkoutStats from '../pre-workout-stats';
import PostWorkoutStats from '../post-workout-stats';
import OverviewBox from '../overview-box';

const StatisticsBox = ({ unitSystem, sharedWorkout: { user }, toggleModal }) => {
  return (
    <section className="stats-overview-section">
      <div className="statistics-container">
        <div className="workout-statistics">
          <h2>
            { user
              ? I18n.translate('[userName]’s', { userName: user.fullname.substr(0, user.fullname.indexOf(' ')) }, 'Adds possessive to a user name. e.g. Joe’s statistics.')
              : <I18n>Workout</I18n>
            }
            &nbsp;<I18n desc="End of sentence fragment announcing the workout statistics of a user.  Example: /Joe's statistics/">statistics</I18n>
          </h2>
          <div className="stats-box">
            { user
              ? <PostWorkoutStats unitSystem={ unitSystem } />
              : <PreWorkoutStats unitSystem={ unitSystem } />
            }
          </div>
        </div>
        <OverviewBox
          toggleModal={ toggleModal }
        />
      </div>
    </section>
  );
};

StatisticsBox.propTypes = {
  sharedWorkout: PropTypes.object.isRequired,
  toggleModal: PropTypes.function,
  unitSystem: PropTypes.string.isRequired
};

const ConnectedStatisticsBox = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout,
    unitSystem: state.user ? state.user.personal.unitSystem : 'standard'
  };
})(StatisticsBox);

export default ConnectedStatisticsBox;